import CrudPage, { fmtMoney } from "../components/CrudPage";
import { Bank } from "@phosphor-icons/react";

const CUR_OPTS = [
  { value: "TRY", label: "₺ TRY" }, { value: "USD", label: "$ USD" }, { value: "EUR", label: "€ EUR" }, { value: "GBP", label: "£ GBP" },
];

export default function BankAccounts() {
  return (
    <CrudPage
      title="Banka Hesapları"
      subtitle="Banka hesaplarınız ve bakiyeleri"
      endpoint="bank-accounts"
      exportEntity="bank-accounts"
      emptyIcon={Bank}
      testidPrefix="bank"
      fields={[
        { name: "name", label: "Hesap Adı" },
        { name: "bank_name", label: "Banka" },
        { name: "account_no", label: "IBAN / Hesap No" },
        { name: "currency", label: "Para Birimi", type: "select", default: "TRY", options: CUR_OPTS },
        { name: "balance", label: "Bakiye", type: "number" },
      ]}
      columns={[
        { key: "name", label: "Hesap Adı" },
        { key: "bank_name", label: "Banka" },
        { key: "account_no", label: "Hesap No" },
        { key: "currency", label: "Birim" },
        { key: "balance", label: "Bakiye", align: "right", render: (i) => fmtMoney(i.balance, i.currency) },
      ]}
    />
  );
}
